import {
    ApolloClient,
    ApolloProvider,
    createHttpLink,
    InMemoryCache
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import ConfirmationModalContainer from "@mostrans/web-components/providers/ConfirmationModalContainer";
import GlobalCss from "@mostrans/web-components/providers/GlobalCss";
import ThemeProvider from "@mostrans/web-components/providers/ThemeProvider";
import ToastContainer from "@mostrans/web-components/providers/ToastContainer";
import "../src/pages/User/Home/Home.css";
import FullScreenLoading from "./components/FullScreenLoading";
import ModalsContainer from "./components/ModalsContainer/ModalsContainer";
import MainRoute from "./router/";
import { ENDPOINT } from "./shared/constants";
import GlobalLoadingScreen from "./shared/GlobalLoadingScreen";
import { getToken } from "./shared/helpers";

function App() {
    // const { ConfirmationModalContainer } = useConfirmationModal()
    const httpLink = createHttpLink({
        uri: ENDPOINT,
    });
    const authLink = setContext((_, { headers }) => {
        // get the authentication token from local storage if it exists
        const token = getToken();
        // return the headers to the context so httpLink can read them
        return {
            headers: {
                ...headers,
                authorization: token ? `Bearer ${token}` : "",
            },
        };
    });

    const client = new ApolloClient({
        link: authLink.concat(httpLink),
        cache: new InMemoryCache(),
        defaultOptions: {
            query: {
                fetchPolicy: "no-cache",
            },
        },
    });


    return (
        <ThemeProvider>
            <GlobalCss />
            <ApolloProvider client={client}>
                <ToastContainer />
                <FullScreenLoading />
                <ModalsContainer />
                <ConfirmationModalContainer />
                <GlobalLoadingScreen />
                {/* <GlobalLoading /> */}
                <MainRoute />
            </ApolloProvider>
        </ThemeProvider>
        // <ApolloProvider client={client}>
        //     {/* <ConfirmationModalContainer /> */}
        //     <GlobalLoadingScreen />
        //     {/* <GlobalLoading /> */}
        //     <MainRoute />
        // </ApolloProvider>
    );
}

export default App;
